import React from 'react';
import { AttachmentVoidFields } from '../api/attachmentVoid';
import { formatDateTimePT } from '../utils/timezone';
import './AttachmentVoid.css';

/** The "Void" badge that sits next to a voided file's name. */
export function AttachmentVoidPill() {
  return <span className="attachment-void-pill">Void</span>;
}

/**
 * Why a file was voided, and by whom — the reason is the point of voiding
 * instead of deleting, so it is shown wherever the file is listed.
 */
export function AttachmentVoidReason({ attachment }: { attachment: Partial<AttachmentVoidFields> }) {
  const reason = attachment.void_reason?.trim();
  if (!reason) return null;
  const who = attachment.voided_by;
  const when = attachment.voided_at ? formatDateTimePT(attachment.voided_at) : null;
  const credit = [who, when].filter(Boolean).join(' · ');
  return (
    <span className="attachment-void-reason">
      Voided: {reason}
      {credit ? <span className="attachment-void-reason-who"> ({credit})</span> : null}
    </span>
  );
}
